import { useCallback, useState } from 'react';
import { TrackSortKey } from '../sortTracks';

/** The column the Tracks table is sorted by. A second click on a column turns the order. */
export function useTrackSort() {
  const [sort, setSort] = useState<{ key: TrackSortKey; descending: boolean }>({ key: 'streams', descending: true });
  const sortBy = useCallback((key: TrackSortKey) => {
    setSort((current) =>
      current.key === key ? { key, descending: !current.descending } : { key, descending: key !== 'name' }
    );
  }, []);
  return { sort, sortBy };
}
